import { render, staticRenderFns } from "./PostFitOutGuidelineSelector.vue?vue&type=template&id=60a53b40&scoped=true&"
import script from "./PostFitOutGuidelineSelector.vue?vue&type=script&lang=js&"
export * from "./PostFitOutGuidelineSelector.vue?vue&type=script&lang=js&"
import style0 from "./PostFitOutGuidelineSelector.vue?vue&type=style&index=0&id=60a53b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a53b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a53b40')) {
      api.createRecord('60a53b40', component.options)
    } else {
      api.reload('60a53b40', component.options)
    }
    module.hot.accept("./PostFitOutGuidelineSelector.vue?vue&type=template&id=60a53b40&scoped=true&", function () {
      api.rerender('60a53b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/PostFitOutGuidelineSelector.vue"
export default component.exports